
class Scale {
  xlim: number[]
  ylim: number[]
  xcan: number[]
  ycan: number[]
  constructor(xlim: number[], ylim: number[], xcan: number[], ycan: number[]) {
    this.xlim = xlim
    this.ylim = ylim
    this.xcan = xcan
    this.ycan = ycan
  }
  x(v: number) {
    const t = (v - this.xlim[0]) / (this.xlim[1] - this.xlim[0])
    return this.xcan[0] + t * (this.xcan[1] - this.xcan[0])
  }
  y(v: number) {
    const t = (v - this.ylim[0]) / (this.ylim[1] - this.ylim[0])
    return this.ycan[0] + t * (this.ycan[1] - this.ycan[0])
  }
}


export class Dumb {
  id: string;
  canvas: any;
  ctx: any;
  pad: number;
  width: number;
  height: number;
  _xlim: number[];
  _ylim: number[];
  _xcan: number[];
  _ycan: number[];
  scale: Scale;
  constructor(id: string) {
    this.id = id
    this.canvas = document.getElementById(id)
    this.ctx = this.canvas.getContext('2d')
    this.pad = 50;
    this._xlim = [0, 1]
    this._ylim = [0, 1]
    this.height = this.canvas.height
    this.width = this.canvas.width
    this._xcan = [this.pad, this.canvas.width - this.pad]
    this._ycan = [this.pad, this.canvas.height - this.pad]
    this.scale = new Scale(this._xlim, this._ylim, this._xcan, this._ycan)
  }
  dpad(x0: number, x1: number, y0: number, y1: number) {
    this._xcan = [this.pad + x0, this.canvas.width - this.pad - x1]
    this._ycan = [this.pad + y0, this.canvas.height - this.pad - y1]
    this.scale = new Scale(this._xlim, this._ylim, this._xcan, this._ycan)
  }

  text(txt: string, x: number, y: number, baseline: string, align: string, color: string = 'black') {
    const ctx = this.ctx
    ctx.fillStyle = color
    ctx.textBaseline = baseline
    ctx.textAlign = align
    ctx.fillText(txt, x, y)
  }

  clear() {
    this.ctx.clearRect(0, 0, this.width, this.height)
  }
  xlim(x0: number, x1: number) {
    this._xlim = [x0, x1]
    this.scale = new Scale(this._xlim, this._ylim, this._xcan, this._ycan)
  }
  ylim(y0: number, y1: number) {
    this._ylim = [y0, y1]
    this.scale = new Scale(this._xlim, this._ylim, this._xcan, this._ycan)
  }
  line(x: number[], y: number[], color: string, lineWidth: number) {
    const ctx = this.ctx
    ctx.save()
    ctx.strokeStyle = color
    ctx.lineWidth = lineWidth
    ctx.beginPath()
    let move = true;
    for (let i = 1; i < x.length; i++) {
      if (x[i] > this._xlim[1] || x[i] < this._xlim[0] ||
        y[i] > this._ylim[1] || y[i] < this._ylim[0])
        continue
      if (move) {
        ctx.moveTo(this.scale.x(x[i]), this.scale.y(y[i]))
        move = false
      } else {
        ctx.lineTo(this.scale.x(x[i]), this.scale.y(y[i]))
      }
    }
    ctx.stroke()
    ctx.restore()
  }

  yaxis(side: string = "left") {
    const ctx = this.ctx
    ctx.strokeStyle = 'black'
    ctx.lineWidth = 1.5
    ctx.beginPath()
    const x = (side == "right") ? (this._xcan[1]) : (this._xcan[0])
    ctx.moveTo(x, this._ycan[0])
    ctx.lineTo(x, this._ycan[1])
    ctx.stroke()
  }
  xaxis(side: string = "top", dy: number = 0) {
    const ctx = this.ctx
    ctx.strokeStyle = 'black'
    ctx.lineWidth = 1.5
    ctx.beginPath()
    let k = (side == "bottom") ? 1 : 0
    ctx.moveTo(this._xcan[0], this._ycan[k] + dy)
    ctx.lineTo(this._xcan[1], this._ycan[k] + dy)
    ctx.stroke()
  }
  xticks(xvals: number[], label: boolean, tick_length: number) {
    const ctx = this.ctx
    ctx.font = `20px Helvetica`;
    ctx.textBaseline = 'bottom'
    ctx.textAlign = 'center';
    for (const xv of xvals) {
      const x = this.scale.x(xv)
      const y = this.scale.y(this.scale.ylim[0])
      if (xv < this._xlim[0] || xv > this._xlim[1])
        continue
      if (label) {
        ctx.fillText(`${xv}`, x, y - tick_length)
      }
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.lineTo(x, y - tick_length)
      ctx.stroke()
    }
  }
  xticks2(xvals: number[], label: boolean, tick_length: number, side: string, fun: any = (x: number) => x, dy: number = 0) {
    xvals = Array.from(xvals)
    let x = xvals.map(v => fun(v)).filter(v => v >= this._xlim[0] && v <= this._xlim[1])
    let y0 = (side == "top") ? this._ylim[0] : this._ylim[1]
    let dir = (side == "top") ? -1 : 1;
    let baseline = (side == "top") ? "bottom" : "top"
    let y = x.map(_v => y0 + dy)
    let txt = xvals.map(v => `${v.toFixed(2)}`)
    this.ticks(x, y, txt, label, [0, dir * tick_length], baseline, 'center')
  }

  ticks(x: number[], y: number[], txt: string[], label: boolean, tick: number[], baseline: string, align: string) {
    const ctx = this.ctx
    ctx.font = `20px Helvetica`;
    ctx.textBaseline = baseline
    ctx.textAlign = align
    ctx.lineWidth = 2
    ctx.strokeStyle = 'black'
    for (let i = 0; i < txt.length; i++) {
      const xv = this.scale.x(x[i])
      const yv = this.scale.y(y[i])
      if (label) {
        ctx.fillText(txt[i], xv + tick[0], yv + tick[1])
      }
      ctx.beginPath()
      ctx.moveTo(xv, yv)
      ctx.lineTo(xv + tick[0], yv + tick[1])
      ctx.stroke()
    }
  }

  yticks(yvals: number[], label: boolean, tick_length: number) {
    const ctx = this.ctx
    ctx.font = `20px Helvetica`;
    ctx.textBaseline = 'middle'
    ctx.textAlign = 'right';
    for (const yv of yvals) {
      const x = this.scale.x(this.scale.xlim[0])
      const y = this.scale.y(yv)
      if (yv < this._ylim[0] || yv > this._ylim[1])
        continue
      if (label) {
        ctx.fillText(`${yv}`, x - tick_length, y)
      }
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.lineTo(x - tick_length, y)
      ctx.stroke()
    }
  }
  yticks2(yvals: number[], label: boolean, tick_length: number, fun: any) {
    const ctx = this.ctx
    ctx.font = `20px Helvetica`;
    ctx.textBaseline = 'middle'
    ctx.textAlign = 'left';
    for (const yv of yvals) {
      const x = this.scale.x(this.scale.xlim[1])
      const y = this.scale.y(fun(yv))
      if (fun(yv) < this._ylim[0] || fun(yv) > this._ylim[1])
        continue
      if (label) {
        ctx.fillText(`${yv}`, x + tick_length, y)
      }
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.lineTo(x + tick_length, y)
      ctx.stroke()
    }
  }

}
